module.exports = __webpack_public_path__ + "files/0004e6dadd812054cb466c786274edcc.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-6.png
// module id = 526
// module chunks = 76